<script setup>
  import useScrollHelper from '@/composables/useScroll';

  const scrollHelper = useScrollHelper();
</script>
<template>
  <footer class="relative py-16 sm:py-24">
    <!-- Background with refined gradient -->
    <div class="absolute inset-0 bg-gradient-to-b from-white to-slate-50 dark:from-slate-800/95 dark:to-slate-900/95">
      <div class="absolute inset-0 bg-[url('/demo/images/landing/grid.svg')] opacity-[0.07]"></div>
    </div>

    <div class="relative max-w-7xl mx-auto px-6 lg:px-8">
      <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        <!-- Company Info -->
        <div class="space-y-4">
          <a
            @click="scrollHelper.smoothScroll('hero')"
            class="flex items-center cursor-pointer"
          >
            <Logo />
          </a>
        </div>

        <!-- Company Links -->
        <div class="space-y-4">
          <h4 class="text-lg font-semibold text-slate-900 dark:text-slate-100">Company</h4>
          <div class="flex flex-col space-y-2">
            <a
              @click="scrollHelper.smoothScroll('contact')"
              class="text-slate-600 dark:text-slate-200 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer transition-colors duration-200"
              >Contact Us</a
            >
            <a
              @click="scrollHelper.smoothScroll('team')"
              class="text-slate-600 dark:text-slate-200 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer transition-colors duration-200"
              >Team</a
            >
          </div>
        </div>

        <!-- Resources -->
        <div class="space-y-4">
          <h4 class="text-lg font-semibold text-slate-900 dark:text-slate-100">Resources</h4>
          <div class="flex flex-col space-y-2">
            <a
              @click="scrollHelper.smoothScroll('features')"
              class="text-slate-600 dark:text-slate-200 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer transition-colors duration-200"
              >Features</a
            >
            <a
              @click="scrollHelper.smoothScroll('pricing')"
              class="text-slate-600 dark:text-slate-200 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer transition-colors duration-200"
              >Pricing</a
            >
          </div>
        </div>

        <!-- Legal -->
        <div class="space-y-4">
          <h4 class="text-lg font-semibold text-slate-900 dark:text-slate-100">Legal</h4>
          <div class="flex flex-col space-y-2">
            <router-link
              to="/privacy-policy#"
              class="text-slate-600 dark:text-slate-200 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer transition-colors duration-200"
            >
              Privacy Policy
            </router-link>
            <router-link
              to="/terms-of-service#"
              class="text-slate-600 dark:text-slate-200 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer transition-colors duration-200"
              >Terms of Service</router-link
            >
          </div>
        </div>
      </div>

      <!-- Bottom border -->
      <div class="mt-12 pt-8 border-t border-slate-200 dark:border-slate-700">
        <p class="text-center text-slate-600 dark:text-slate-200">© {{ new Date().getFullYear() }} Teacher Toolbox. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>
